import type { BulleEnAnalyse } from './loupeDeLaCarte';
import { IconeHorloge } from './icones';
import './BulleEnAnalyse.css';

/*
 * **Ce que dit une bulle en Analyse** (chantier theme-analyse, ticket 02 ; maquette
 * `quatre-themes.html`, `contenu`, `.jn`, `.pulse`), sur la Carte (`NoeudCarte`) et la Hiérarchie
 * (`NoeudHierarchie`), écrit une fois : sa durée sous son titre, son compte à rebours dans son coin.
 * Les mots viennent de la loupe (`useTouchesDeLaCarte`) ; ici, seulement le dessin.
 */

/** La classe qui fait luire une bulle dont la date est à 30 jours ou moins. */
export function classeDeLaLueur(analyse: BulleEnAnalyse | null | undefined): string {
  return analyse?.lueur ? 'en-analyse--lueur' : '';
}

/** Sa durée, sous le titre, à la place de la ligne des réglages. */
export function DureeEnAnalyse({ classe, analyse }: { classe: string; analyse: BulleEnAnalyse }) {
  if (!analyse.duree) return null;
  return (
    <span className={`${classe} duree-en-analyse`}>
      <IconeHorloge className="duree-en-analyse-icone" />
      {analyse.duree}
    </span>
  );
}

/** Son compte à rebours, dans le coin : J-n, plus vif à 30 jours, plein à 7. */
export function ReboursEnAnalyse({ analyse }: { analyse: BulleEnAnalyse | null | undefined }) {
  if (!analyse?.rebours) return null;
  return (
    <span className={`rebours-en-analyse${analyse.lueur ? ` rebours-en-analyse--${analyse.lueur}` : ''}`}>
      {analyse.rebours}
    </span>
  );
}
